import { boxToPoints, findCenterOfPoints } from "@logic/lib/2d"

import type { TransactionOperation } from "."
import { findPanelState } from "../panels"

export const findCenterOfPanels: TransactionOperation<
  string[],
  { x: number; y: number }
> = (transactors, panelsOfArea) => {
  const { get } = transactors
  const selectedPanels = [...panelsOfArea].map((id) => get(findPanelState(id)))
  const allOriginalPanelPoints = [...selectedPanels]
    .map((panel) => boxToPoints(panel))
    .flat()
  const centerPoint = findCenterOfPoints(...allOriginalPanelPoints)

  return centerPoint
}
